var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbRp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.602,
    height: 215.404,
    viewBox: "0 0 143.602 215.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(-47.061 -626.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M190.662,626.246H47.061v215.4h143.6v-215.4Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(49.146 628.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M187.068,626.885V837.674H47.637V626.885H187.068",
    transform: "translate(-47.637 -626.885)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 124.392,
    height: 34.953,
    transform: "translate(7.017 7.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 124.463,
    height: 128.495,
    transform: "translate(6.961 50.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(6.985 185.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M49.567,695.382V678.321H74.555v3.993H59.607v2.438H72.258v3.979H59.607V691.4H75.134v3.979Z",
    transform: "translate(-49.567 -677.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M75.184,683.6a1.878,1.878,0,0,0-1.447-1.151,9.013,9.013,0,0,0-2.595-.318c-2.207,0-3.2.362-3.2,1,0,2.522,17.619.937,17.619,7.143,0,3.951-5.924,5.88-14.34,5.88-8.084,0-13.356-2.631-13.57-5.71h9.615a2.426,2.426,0,0,0,1.665,1.343,9.1,9.1,0,0,0,2.859.431c2.508,0,4.176-.445,4.176-1.252,0-2.583-17.633-.811-17.633-7.313,0-3.626,5.616-5.442,13.284-5.442,8.5,0,12.376,2.41,13.114,5.392Z",
    transform: "translate(-28.387 -678.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M76.787,685.721h3.948c3.108,0,4.777-.452,4.777-1.625,0-1.2-1.7-1.78-4.046-1.78H76.787Zm0,3.72v5.942H66.749V678.321H81.22c10.2,0,13.566,1.563,13.566,4.878,0,1.972-1.567,3.611-5.146,4.183,3.231.651,5.193,1.053,5.193,4.494,0,2.222-.13,2.992,1.06,2.992v.514H85.714a6.623,6.623,0,0,1-.5-2.982c0-2.24-.684-2.96-5.363-2.96Z",
    transform: "translate(-4.576 -677.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M86.236,682.316v2.855h4.183c2,0,3.452-.517,3.452-1.491,0-1.335-1.979-1.364-4.089-1.364Zm0,5.942V691.4h4.378c2.49,0,4.357-.289,4.357-1.56,0-1.491-2.334-1.585-5.544-1.585ZM76.2,695.383V678.321H90.846c6.9,0,12.386.927,12.386,4.306,0,1.759-2.052,3.04-4,3.7,3.315.481,5.095,2.077,5.095,3.908,0,3.8-5.222,5.146-13.193,5.146Z",
    transform: "translate(20.177 -677.898)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(10.494 60.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M113.851,701.681c-2.077-7.689-6.2-12.187-12.075-13.758,3.655-4.273,5.732-10.885,2.935-21.27-3.93-14.5-13.906-21.531-26.032-18.3L51.1,655.689l-.565.145,22.84,84.5,18.447-4.918s-7.483-27.671-8.793-32.545l.9-.239c2.819-.731,4.878-.724,6.257.076,2.443,1.4,3.572,5.627,4.863,10.516l1.031,3.893c1.2,4.7,2.475,9.568,5.652,13.711l1.238,1.632,21.1-5.591-2.833-3.626C119.811,721.42,116.265,710.619,113.851,701.681Zm-30.19-15.1s-2.367.633-4.7,1.248c-1.379-5.091-4.538-16.8-5.916-21.9,2.316-.6,4.7-1.238,4.7-1.238,2.233-.586,5.967-1.585,8.7,8.532C86.969,675.186,89.346,685.064,83.661,686.577Z",
    transform: "translate(-50.537 -633.33)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M94.56,644.627l-24.845,6.6-2.985.789,22.83,84.512,18.856-5s-7.346-27.161-8.666-32.006c3.184-.858,8.109-2.149,8.109-2.149,14.71-3.926,20.333-15.328,15.784-32.1C117.737,643.4,104.58,641.978,94.56,644.627Zm7.686,37.5s-3.629.97-6.712,1.788c-1.342-4.994-4.57-16.888-5.906-21.885,2.736-.727,5.721-1.516,5.721-1.516,3.249-.872,6.962-.872,9.908,10.016C106.665,675.71,105.2,681.348,102.246,682.13Z",
    transform: "translate(-8.134 -643.643)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(10.465 14.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M53.011,650.89H50.529V631.046h4.585a2.266,2.266,0,0,1,2.03,1.317,8.064,8.064,0,0,1,.745,3.876,8.937,8.937,0,0,1-.5,3.217,2.488,2.488,0,0,1-1.7,1.65v.054c.134.036.318.091.557.167a1.63,1.63,0,0,1,.716.492,3.342,3.342,0,0,1,.615,1.143,6.7,6.7,0,0,1,.261,2.1c0,.311.007.753.011,1.317s.018,1.154.04,1.762.054,1.161.09,1.672a6.355,6.355,0,0,0,.141,1.075H55.689a7.424,7.424,0,0,1-.257-1.9c0-.662,0-1.31,0-1.95,0-.586,0-1.147-.007-1.679a5.688,5.688,0,0,0-.17-1.386,1.983,1.983,0,0,0-.525-.952,1.494,1.494,0,0,0-1.071-.355h-.644Zm0-11.272h1.1a.792.792,0,0,0,.612-.271,2.069,2.069,0,0,0,.391-.7,4.749,4.749,0,0,0,.21-.948c.033-.347.054-.68.054-.991a4.313,4.313,0,0,0-.34-2.019,1.018,1.018,0,0,0-.926-.586h-1.1Z",
    transform: "translate(-50.529 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M52.818,650.89,56.1,631.046h3.268l3.221,19.844H59.979l-.659-4.4H55.937l-.673,4.4Zm4.78-16.023h-.036l-1.136,8.576H58.8Z",
    transform: "translate(-44.535 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M63.31,631.046v3.3H60.552V650.89H58.07V634.342H55.309v-3.3Z",
    transform: "translate(-38.012 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M57.838,650.89V631.046h2.479V650.89Z",
    transform: "translate(-31.39 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M59.1,650.89V631.046h3.347l3.155,13.743h.033V631.046h2.316V650.89H64.684l-3.228-14.51H61.42v14.51Z",
    transform: "translate(-28.075 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M67.629,637.384c0-.456-.014-.9-.043-1.314a4.373,4.373,0,0,0-.2-1.1,1.939,1.939,0,0,0-.449-.76,1.112,1.112,0,0,0-.789-.286.963.963,0,0,0-.887.6,5.268,5.268,0,0,0-.463,1.625,18,18,0,0,0-.17,2.348c-.022.89-.029,1.809-.029,2.765,0,1.552.029,2.812.087,3.763a13.1,13.1,0,0,0,.275,2.215,1.948,1.948,0,0,0,.543,1.053,1.349,1.349,0,0,0,.868.275,1.933,1.933,0,0,0,.633-.1,4.436,4.436,0,0,0,.6-.275v-4.4H66.268v-3.051h3.825V650.8c-.163.054-.387.119-.666.192s-.579.145-.894.221-.637.13-.955.181a6.907,6.907,0,0,1-.84.065,4.784,4.784,0,0,1-2.486-.561,3.465,3.465,0,0,1-1.4-1.817,11.287,11.287,0,0,1-.615-3.231c-.1-1.317-.141-2.917-.141-4.806q0-1.872.09-3.684a14.209,14.209,0,0,1,.492-3.231,5.26,5.26,0,0,1,1.248-2.294,3.134,3.134,0,0,1,2.374-.883,3.167,3.167,0,0,1,1.632.427,3.605,3.605,0,0,1,1.234,1.238,6.119,6.119,0,0,1,.738,2.008,12.017,12.017,0,0,1,.188,2.757Z",
    transform: "translate(-20.24 -630.954)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M65.912,631.046h4.473a2.547,2.547,0,0,1,1.455.409,3.063,3.063,0,0,1,.97,1.2,6.476,6.476,0,0,1,.554,1.885,15.7,15.7,0,0,1,.177,2.443,16.862,16.862,0,0,1-.116,1.871,7.148,7.148,0,0,1-.445,1.9,3.863,3.863,0,0,1-1,1.469,2.524,2.524,0,0,1-1.744.59H68.394v8.08H65.912Zm2.482,8.713h1.379a.7.7,0,0,0,.51-.231,2.056,2.056,0,0,0,.394-.608,4.05,4.05,0,0,0,.257-.85,5.511,5.511,0,0,0,.087-.977c0-.405-.022-.789-.054-1.158a4.038,4.038,0,0,0-.213-.959,1.6,1.6,0,0,0-.431-.644,1,1,0,0,0-.688-.231H68.394Z",
    transform: "translate(-10.248 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M68.431,650.89V631.046H74.9V634.1H70.91v4.889h3.68v3.051H70.91v5.8h4.129v3.054Z",
    transform: "translate(-3.651 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M70.705,650.89V631.046h3.351l3.155,13.743h.036V631.046h2.309V650.89H76.292l-3.235-14.51h-.036v14.51Z",
    transform: "translate(2.303 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M73.742,631.046h4.136a2.9,2.9,0,0,1,1.976.658,4.291,4.291,0,0,1,1.172,1.925,13.2,13.2,0,0,1,.565,3.09c.1,1.219.148,2.6.148,4.14v1.8c0,.688-.029,1.408-.08,2.157a17.075,17.075,0,0,1-.308,2.215,7.244,7.244,0,0,1-.662,1.94,4.081,4.081,0,0,1-1.151,1.386,2.841,2.841,0,0,1-1.759.536H73.742Zm2.479,16.79h1.2a1.219,1.219,0,0,0,.912-.365,2.588,2.588,0,0,0,.546-1.194,12.417,12.417,0,0,0,.271-2.135q.076-1.3.076-3.173c0-.919-.011-1.788-.025-2.613a14.112,14.112,0,0,0-.192-2.186,4.18,4.18,0,0,0-.514-1.509,1.107,1.107,0,0,0-1-.561H76.221Z",
    transform: "translate(10.256 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M76.5,650.89V631.046h2.479V650.89Z",
    transform: "translate(17.486 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M77.769,650.89V631.046h3.347l3.152,13.743H84.3V631.046H86.62V650.89H83.349l-3.235-14.51h-.036v14.51Z",
    transform: "translate(20.801 -630.713)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M86.294,637.384c0-.456-.014-.9-.043-1.314a4.543,4.543,0,0,0-.2-1.1,1.908,1.908,0,0,0-.456-.76,1.088,1.088,0,0,0-.789-.286.967.967,0,0,0-.887.6,5.089,5.089,0,0,0-.456,1.625,18.543,18.543,0,0,0-.177,2.348c-.011.89-.022,1.809-.022,2.765,0,1.552.025,2.812.083,3.763a12.679,12.679,0,0,0,.279,2.215,1.948,1.948,0,0,0,.539,1.053,1.359,1.359,0,0,0,.872.275,1.965,1.965,0,0,0,.633-.1,4.6,4.6,0,0,0,.6-.275v-4.4h-1.35v-3.051h3.828V650.8c-.166.054-.387.119-.662.192s-.583.145-.9.221-.633.13-.952.181a6.8,6.8,0,0,1-.836.065,4.807,4.807,0,0,1-2.49-.561,3.488,3.488,0,0,1-1.4-1.817,11.411,11.411,0,0,1-.615-3.231c-.09-1.317-.134-2.917-.134-4.806,0-1.248.025-2.475.087-3.684a14.412,14.412,0,0,1,.492-3.231,5.292,5.292,0,0,1,1.245-2.294,3.515,3.515,0,0,1,4.009-.456,3.6,3.6,0,0,1,1.234,1.238,6.118,6.118,0,0,1,.738,2.008,12.227,12.227,0,0,1,.188,2.757Z",
    transform: "translate(28.636 -630.954)",
    fill: "#1a1818"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbRp);
export default __webpack_public_path__ + "static/media/esrb-rp.30a72a51d1f0af7a5fb2ba05ed8c4459.svg";
export { ForwardRef as ReactComponent };